// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const SAVE_ORIGINAL_TOKEN = 'SAVE_ORIGINAL_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const REVERT_ORIGINAL_TOKEN = 'REVERT_ORIGINAL_TOKEN'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// navigation.js
export const SET_NAV_ITEMS = 'SET_NAV_ITEMS'
export const SET_SECONDARY_NAV_ITEMS = 'SET_SECONDARY_NAV_ITEMS'
export const SET_STANDALONE_NAV_ITEMS = 'SET_STANDALONE_NAV_ITEMS'
export const SET_APO_ONE_NAV_ITEMS = 'SET_APO_ONE_NAV_ITEMS'
